// extracted by mini-css-extract-plugin
module.exports = {"ScrollUpButtonContainer":"global-module--ScrollUpButtonContainer--2nDC5","ScrollUpButtonToggled":"global-module--ScrollUpButtonToggled--1Bw5e"};